import createSubmit from '../../Form/createSubmitButton.jsx'
import { name } from './OfferForm.jsx'
export default createSubmit(name)